import './Schools.css'
import { useEffect, useState, useRef } from 'react'
import { Button, CircularProgress, TextField, Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Box, InputAdornment, Typography, FormControlLabel, Switch } from '@mui/material'
import { QRCodeCanvas } from 'qrcode.react';
import { useSnackbar } from 'notistack'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import * as XLSX from 'xlsx';
import {
  Tooltip, Tabs, Tab, Alert, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Chip
} from '@mui/material';
// Components
import StandardPageWrapper from '../../../components/StandardPageWrapper/StandardPageWrapper'
import StandardButton from '../../../components/StandardButton/StandardButton';
import StandardOutlinedTextfield from '../../../components/StandardOutlinedTextfield/StandardOutlinedTextfield'
import ReactCustomTable from '../../../components/ReactCustomTable/ReactCustomTable'
import StandardMuiDialogWrapper from '../../../components/StandardMuiDialogWrapper/StandardMuiDialogWrapper'
import DifferenceIcon from '@mui/icons-material/Difference';
import { Delete, Edit, ArrowForward, Download, ContentCopy, Visibility, Refresh, PowerSettingsNew, AccountBalanceWallet, AddCircleOutline, RemoveCircleOutline, History, Close } from '@mui/icons-material'




function Schools() {
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();

  const [allSchoolData, setAllSchoolData] = useState([]);
  const [allSchoolDataLoading, setAllSchoolDataLoading] = useState(true);

  const [downloadAllLoading, setDownloadAllLoading] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogBtnLoading, setDialogBtnLoading] = useState(false);
  const [addSchoolData, setAddSchoolData] = useState({
    name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: ''
    , final_count: '', is_ids: 1
  });
  // Delete
  const [deleteID, setDeleteID] = useState('');
  const [deleteLoading, setDeleteLoading] = useState(false);
  // Edit
  const [editActive, setEditActive] = useState(false);
  const [editId, setEditId] = useState('');
  // Download
  const [downloadId, setDownloadId] = useState('');
  const [downloadLoading, setDownloadLoading] = useState(false);
  // Search
  const [searchInput, setSearchInput] = useState("");

  //Show QR
  const [qrOpen, setQrOpen] = useState(false);
  const [qrData, setQrData] = useState("");
  const qrRef = useRef(null);
  const [qrFileName, setQrFileName] = useState("");
  const [schoolName, setSchoolName] = useState("");
  const [refreshSchools, setRefreshSchools] = useState(0);

  // Pagination states
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

  // Status Filter ('all' | 'active' | 'deactivated')
  const [statusFilter, setStatusFilter] = useState("all");
  const [activeCount, setActiveCount] = useState(0);
  const [deactivatedCount, setDeactivatedCount] = useState(0);

  // Toggle status dialog states
  const [openStatusDialog, setOpenStatusDialog] = useState(false);
  const [statusTargetSchool, setStatusTargetSchool] = useState(null);
  const [statusReason, setStatusReason] = useState("");
  const [statusBtnLoading, setStatusBtnLoading] = useState(false);
  const [syncLoading, setSyncLoading] = useState(false);

  //for sending to login field
  const [openCopyTextDialog, setOpenCopyTextDialog] = useState(false);
  const [copyText, setCopyText] = useState("");
  const [selectedRow, setSelectedRow] = useState(null);

  // Delete confirmation dialog
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // Manage credits dialog (Add / Deduct / History)
  const [openRechargeDialog, setOpenRechargeDialog] = useState(false);
  const [rechargeTargetSchool, setRechargeTargetSchool] = useState(null);
  const [creditActionType, setCreditActionType] = useState('add'); // 'add' | 'deduct'
  const [rechargeCredits, setRechargeCredits] = useState('');
  const [rechargeRemarks, setRechargeRemarks] = useState('');
  const [rechargeLoading, setRechargeLoading] = useState(false);
  const [creditDialogTab, setCreditDialogTab] = useState(0); // 0: Manage, 1: History
  const [creditLogs, setCreditLogs] = useState([]);
  const [creditLogsLoading, setCreditLogsLoading] = useState(false);




  useEffect(() => {
    fetchAllSchools();
  }, [refreshSchools, page, limit, searchInput, statusFilter])

  const fetchAllSchools = async () => {
    setAllSchoolDataLoading(true);
    await axios.get(`${process.env.REACT_APP_BASE_URL}/user/getallschool`, {
      params: { page, limit, search: searchInput, status: statusFilter }
    })
      .then(res => {
        if (res.data.success) {
          setAllSchoolData(res.data.data);
          setTotalCount(res.data.totalCount || 0);
          if (res.data.activeCount !== undefined) setActiveCount(res.data.activeCount);
          if (res.data.deactivatedCount !== undefined) setDeactivatedCount(res.data.deactivatedCount);
        } else {
          enqueueSnackbar('Error Fetching Schools, Try Again !!!', { variant: 'error' })
        }
        setAllSchoolDataLoading(false);
      })
      .catch(err => {
        console.log(err);
        setAllSchoolDataLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const handleOpenToggleStatusDialog = (school) => {
    setStatusTargetSchool(school);
    setStatusReason(
      Number(school.is_active) === 1
        ? "Manual deactivation by Admin"
        : ""
    );
    setOpenStatusDialog(true);
  };

  const handleCloseStatusDialog = () => {
    setOpenStatusDialog(false);
    setStatusTargetSchool(null);
    setStatusReason("");
  };

  const handleConfirmToggleStatus = async () => {
    if (!statusTargetSchool) return;
    setStatusBtnLoading(true);
    const willBeActive = Number(statusTargetSchool.is_active) === 1 ? 0 : 1;
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/toggle-school-status`, {
        schoolid: statusTargetSchool.schoolid,
        is_active: willBeActive,
        reason: statusReason
      });
      if (res.data.success) {
        enqueueSnackbar(
          res.data.message || (willBeActive ? 'School activated successfully!' : 'School deactivated successfully!'),
          { variant: 'success' }
        );
        handleCloseStatusDialog();
        setRefreshSchools(prev => prev + 1);
      } else {
        enqueueSnackbar(res.data.message || 'Failed to update status', { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Error toggling school status', { variant: 'error' });
    } finally {
      setStatusBtnLoading(false);
    }
  };

  const handleSyncInactivity = async () => {
    setSyncLoading(true);
    try {
      const res = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/sync-schools-activity`);
      if (res.data.success) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRefreshSchools(prev => prev + 1);
      } else {
        enqueueSnackbar(res.data.message || 'Sync failed', { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar('Error syncing inactivity', { variant: 'error' });
    } finally {
      setSyncLoading(false);
    }
  };

  const fetchSchoolCreditLogs = async (schoolid) => {
    if (!schoolid) return;
    setCreditLogsLoading(true);
    try {
      const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/user/get-school-credits/${schoolid}`);
      if (res.data.success) {
        setCreditLogs(res.data.logs || []);
        if (res.data.credits !== undefined) {
          setRechargeTargetSchool(prev => prev ? { ...prev, credits: res.data.credits } : prev);
        }
      }
    } catch (err) {
      console.error('Error fetching credit logs:', err);
    } finally {
      setCreditLogsLoading(false);
    }
  };

  const handleOpenRechargeDialog = (school) => {
    setRechargeTargetSchool(school);
    setCreditActionType('add');
    setRechargeCredits('');
    setRechargeRemarks('');
    setCreditDialogTab(0);
    setCreditLogs([]);
    setOpenRechargeDialog(true);
    fetchSchoolCreditLogs(school.schoolid);
  };

  const handleConfirmCreditAction = async () => {
    const amt = parseInt(rechargeCredits, 10);
    if (!rechargeTargetSchool?.schoolid || isNaN(amt) || amt <= 0) {
      return enqueueSnackbar('Please enter a valid credit amount greater than 0', { variant: 'warning' });
    }

    const currentBal = Number(rechargeTargetSchool.credits) || 0;

    if (creditActionType === 'deduct') {
      if (currentBal <= 0) {
        return enqueueSnackbar('This school has 0 credits. Cannot deduct credits.', { variant: 'error' });
      }
      if (amt > currentBal) {
        return enqueueSnackbar(`Cannot deduct ${amt} credits. Current balance is only ${currentBal} credits.`, { variant: 'error' });
      }
    }

    setRechargeLoading(true);
    try {
      const endpoint = creditActionType === 'deduct'
        ? `${process.env.REACT_APP_BASE_URL}/user/deduct-school-credits`
        : `${process.env.REACT_APP_BASE_URL}/user/add-school-credits`;

      const defaultRemark = creditActionType === 'deduct' ? 'Deduction by Admin' : 'Recharge by Admin';

      const res = await axios.post(endpoint, {
        schoolid: rechargeTargetSchool.schoolid,
        credits: amt,
        remarks: rechargeRemarks || defaultRemark,
        performed_by: 'Admin'
      });

      if (res.data.success) {
        const actionVerb = creditActionType === 'deduct' ? 'deducted' : 'added';
        enqueueSnackbar(`Successfully ${actionVerb} ${amt} credits ${creditActionType === 'deduct' ? 'from' : 'to'} ${rechargeTargetSchool.name}!`, { variant: 'success' });
        const newBal = res.data.balance !== undefined
          ? res.data.balance
          : (creditActionType === 'deduct' ? currentBal - amt : currentBal + amt);

        setAllSchoolData(prev => prev.map(s => {
          if (s.schoolid === rechargeTargetSchool.schoolid) {
            return { ...s, credits: newBal };
          }
          return s;
        }));

        setRechargeTargetSchool(prev => prev ? { ...prev, credits: newBal } : prev);
        setRechargeCredits('');
        setRechargeRemarks('');
        setOpenRechargeDialog(false);
      } else {
        enqueueSnackbar(res.data.message || 'Operation failed', { variant: 'error' });
      }
    } catch (err) {
      console.error(err);
      enqueueSnackbar(err.response?.data?.message || 'Error processing credit transaction', { variant: 'error' });
    } finally {
      setRechargeLoading(false);
    }
  };

  const formatCreditDate = (dateStr) => {
    if (!dateStr) return '-';
    try {
      const d = new Date(dateStr);
      return d.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
      });
    } catch (e) {
      return dateStr;
    }
  };

  const handleOpenTextDialog = () => {
    setCopyText("");
    setOpenCopyTextDialog(true);
  };

  const handleCloseTextDialog = (e) => {
    e?.stopPropagation();
    setOpenCopyTextDialog(false);
  };


  const handleSubmitCopyText = () => {
    onCopyLink1(selectedRow, copyText);
    setOpenCopyTextDialog(false);
  };



  const onExited = () => {
    setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '', final_count: '' });
    setEditActive(false);
  }

  // Auto-generate school ID and password based on school name
  const generateSchoolCredentials = (schoolName) => {
    if (!schoolName || schoolName.trim() === '') {
      return { school_login_id: '', secret_code: '' };
    }

    const skipWords = ['of', 'the', 'and', 'or', 'for', 'in', 'on', 'at', 'to', 'a', 'an', 'is', 'as'];

    // Clean and split words
    const words = schoolName.trim()
      .split(/\s+/)
      .filter(word => word.length > 0)
      .map(word => word.replace(/[^a-zA-Z0-9]/g, '')) // Remove special characters
      .filter(word => word.length > 0);

    let schoolId = '';

    if (words.length === 1) {
      // Single word: Take first 5-6 characters (uppercase)
      const word = words[0];
      const prefix = word.substring(0, Math.min(6, word.length)).toUpperCase();
      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${prefix}${randomNum}`;
    } else if (words.length === 2) {
      // Two words: Take 4 chars from first word + 3 chars from second word
      const firstPart = words[0].substring(0, Math.min(4, words[0].length)).toUpperCase();
      const secondPart = words[1].substring(0, Math.min(3, words[1].length)).toUpperCase();
      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${firstPart}${secondPart}${randomNum}`;
    } else {
      // Multiple words: Use first letter (initial) of each significant word
      // Filter out common words like "of", "and", "the", etc.
      const significantWords = words.filter(word =>
        !skipWords.includes(word.toLowerCase())
      );

      // If we filtered out too many, use all words
      const wordsToUse = significantWords.length >= 2 ? significantWords : words;

      // Take first letter of each word
      const initials = wordsToUse.map(word =>
        word.charAt(0).toUpperCase()
      ).join('');

      const randomNum = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
      schoolId = `${initials}${randomNum}`;
    }

    // Generate Password: Based on school name with special characters and numbers
    const specialChars = ['@', '#', '$', '%', '&', '*', '!'];
    const nameLower = schoolName.toLowerCase().replace(/\s/g, '').replace(/[^a-z0-9]/g, '');
    const nameLength = nameLower.length;
    const nameLengthStr = nameLength.toString();
    const randomSpecial = specialChars[Math.floor(Math.random() * specialChars.length)];
    const randomNum2 = Math.floor(Math.random() * 100).toString().padStart(2, '0');

    // Create password: first 4-5 chars of name + special char + numbers + last 2 chars
    const namePrefix = nameLower.substring(0, Math.min(5, nameLower.length));
    const nameSuffix = nameLower.substring(Math.max(0, nameLower.length - 2));
    const password = `${namePrefix}${randomSpecial}${nameLengthStr}${randomNum2}${nameSuffix}`;

    return { school_login_id: schoolId, secret_code: password };
  }

  // Handle school name change and auto-generate credentials
  const handleSchoolNameChange = (value) => {
    const updatedData = { ...addSchoolData, name: value };

    // Only auto-generate if we're in "Add" mode (not editing)
    // This allows the fields to be editable - user can modify the generated values
    if (!editActive && value.trim() !== '') {
      const generated = generateSchoolCredentials(value);
      updatedData.school_login_id = generated.school_login_id;
      updatedData.secret_code = generated.secret_code;
    }

    setAddSchoolData(updatedData);
  }

  // Regenerate/Scramble login ID while keeping it related to school name
  const regenerateLoginId = () => {
    if (!addSchoolData.name || addSchoolData.name.trim() === '') {
      enqueueSnackbar('Please enter school name first!', { variant: 'warning' });
      return;
    }

    // Generate a completely new ID based on school name
    // This will create a different ID each time by using a new random number
    const generated = generateSchoolCredentials(addSchoolData.name);

    setAddSchoolData({ ...addSchoolData, school_login_id: generated.school_login_id });
    enqueueSnackbar('Login ID regenerated!', { variant: 'info' });
  }

  const onDownloadAllClick = () => {
    if (allSchoolDataLoading) return;
    setDownloadAllLoading(true);
    if (allSchoolData?.length <= 0) return enqueueSnackbar('No Data Found', { variant: 'error' })
    // const excelHeaders = Object.keys(res.data.data?.[0])
    try {
      var fixedHeaders = [
      ];

      var dynamicHeaders = Object.keys(allSchoolData?.[0]).filter(
        (header) => !fixedHeaders.includes(header)
      );

      var allHeaders = fixedHeaders.concat(dynamicHeaders);

      var worksheet = XLSX.utils.json_to_sheet(allSchoolData, {
        header: allHeaders,
      });
      const wb = { Sheets: { 'ID SOLUTIONS Schools': worksheet }, SheetNames: ['ID SOLUTIONS Schools'] };
      XLSX.writeFile(wb, 'ID SOLUTIONS Institute List.xls');

      setDownloadAllLoading(false);
    }
    catch (err) {
      console.log(err);
      setDownloadLoading(false);
      return enqueueSnackbar('Something Went Wrong Downloading !!!', { variant: 'error' })
    }
  }

  const onAddSchool = async () => {
    // Exclude 'final_count' from the empty check
    const { final_count, ...rest } = addSchoolData || {};
    if (Object.values(rest)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })
    setDialogBtnLoading(true);

    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/addschool`, addSchoolData)
      .then(res => {
        if (res.data.success) {
          // setAllSchoolData([...allSchoolData, res.data.result[0]])
          enqueueSnackbar('School Added Successfully !!!', { variant: 'success' })
          setOpenDialog(false);
          setDialogBtnLoading(false);
          fetchAllSchools();
        } else {
          // Check if error is "login id already"
          const errorMessage = res.data.message || res.data.result || '';
          const isLoginIdExists = errorMessage.toLowerCase().includes('login id already') ||
            errorMessage.toLowerCase().includes('login id') ||
            (res.data.result && typeof res.data.result === 'string' && res.data.result.toLowerCase().includes('login id already'));

          if (isLoginIdExists) {
            enqueueSnackbar('Login ID already exists! Please click refresh button to generate a new one.', { variant: 'error' })
            // Keep dialog open - don't close it
          } else {
            enqueueSnackbar(errorMessage || 'Error adding school!', { variant: 'error' })
            // Keep dialog open for other errors too, so user can fix and retry
          }
          setDialogBtnLoading(false);
        }
      })
      .catch(err => {
        console.log(err);
        setDialogBtnLoading(false);
        // Check response data for login id error
        const errorResult = err.response?.data?.result || '';
        const errorMessage = err.response?.data?.message || '';
        if ((typeof errorResult === 'string' && errorResult.toLowerCase().includes('login id already')) ||
          (typeof errorMessage === 'string' && errorMessage.toLowerCase().includes('login id already'))) {
          enqueueSnackbar('Login ID already exists! Please click refresh button to generate a new one.', { variant: 'error' })
        } else {
          enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
        }
        // Keep dialog open on error
      })
  }

  const onDelete = (e, data) => {
    e.stopPropagation();

    if (!data?.schoolid) {
      return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' });
    }

    setDeleteTarget(data);
    setOpenDeleteDialog(true);
  };


  const confirmDeleteSchool = async () => {
    if (!deleteTarget?.schoolid) return;

    setDeleteID(deleteTarget.schoolid);
    setDeleteLoading(true);

    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/user/deleteschool`,
        { schoolid: deleteTarget.schoolid }
      );

      if (res.data.success) {
        setAllSchoolData(prev =>
          prev.filter(s => s.schoolid !== deleteTarget.schoolid)
        );
        enqueueSnackbar('School Deleted Successfully !!!', { variant: 'success' });
      } else {
        enqueueSnackbar('Error Deleting School, Try Again !!!', { variant: 'error' });
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
    } finally {
      setDeleteID('');
      setDeleteLoading(false);
      setOpenDeleteDialog(false);
      setDeleteTarget(null);
    }
  };

  const cancelDeleteSchool = () => {
    setOpenDeleteDialog(false);
    setDeleteTarget(null);
  };




  const onEdit = (e, data) => {
    e.stopPropagation();
    if (!data.schoolid) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    setEditId(data.schoolid);
    setOpenDialog(true);
    setEditActive(true);
    setAddSchoolData({
      name: data?.name, address: data?.address, school_login_id: data?.school_login_id, secret_code: data?.secret_code,
      contact_person: data?.contact_person, del_address: data?.del_address, con_mobile: data?.con_mobile, final_count: data?.final_count, is_ids: data?.is_ids
    })
  }

  const onSaveEdit = async () => {
    if (!editId) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    if (Object.values(addSchoolData)?.includes('')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' })

    setDialogBtnLoading(true);

    let body = { ...addSchoolData, schoolid: editId, is_ids: addSchoolData.is_ids ? 1 : 0 }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateschool`, body)
      .then(res => {
        if (res.data.success) {
          const editDataIndex = allSchoolData.findIndex(i => i.schoolid == editId);
          if (editDataIndex === -1) return enqueueSnackbar('Error Updating School !!!', { variant: 'success' })

          let arr = [...allSchoolData]
          arr[editDataIndex] = body;
          setAllSchoolData(arr)
          enqueueSnackbar('School Updated Successfully !!!', { variant: 'success' })
          setRefreshSchools(prev => prev + 1);
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setOpenDialog(false);
        setEditActive(false);
        setDialogBtnLoading(false);
        setEditId('');
        setAddSchoolData({ name: '', address: '', school_login_id: '', secret_code: '', contact_person: '', del_address: '', con_mobile: '' });
      })
      .catch(err => {
        console.log(err);
        setDialogBtnLoading(false);
        return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
      })
  }

  const onDownloadClick = async (e, data) => {
    e.stopPropagation();
    if (downloadLoading) return;
    if (!data?.verified_count || data?.verified_count <= 0) return enqueueSnackbar('No ID Cards Mapped To This School !!!', { variant: 'error', preventDuplicate: false })
    if (!data?.schoolid) return enqueueSnackbar('School ID Not Found !!!', { variant: 'error' })
    setDownloadId(data?.schoolid);
    setDownloadLoading(true);

    let body = { id: data?.schoolid }
    await axios.post(`${process.env.REACT_APP_BASE_URL}/user/schoolexportexcel`, body)
      .then(res => {
        if (res.data.success) {
          if (res.data.data?.length <= 0) return enqueueSnackbar('No Data Found', { variant: 'error' })

          // const excelHeaders = Object.keys(res.data.data?.[0])

          var fixedHeaders = [
            "first_name_student",
            "phone_no_student",
            "class_id_student",
            "school_id_student",
            "Photo",
            "class_id"
          ];

          var dynamicHeaders = Object.keys(res.data.data?.[0]).filter(
            (header) => !fixedHeaders.includes(header)
          );

          var allHeaders = fixedHeaders.concat(dynamicHeaders);

          var worksheet = XLSX.utils.json_to_sheet(res.data.data, {
            header: allHeaders,
          });
          const wb = { Sheets: { 'ID SOLUTIONS Schools': worksheet }, SheetNames: ['ID SOLUTIONS Schools'] };
          XLSX.writeFile(wb, 'ID SOLUTIONS.xls');
        } else {
          enqueueSnackbar(res.data.message, { variant: 'error' })
        }
        setDownloadLoading(false);
      })
      .catch(err => {
        console.log(err);
        setDownloadLoading(false);
        return enqueueSnackbar('Something Went Wrong Downloading !!!', { variant: 'error' })
      })
  }

  const showQr = (e, data) => {
    e.stopPropagation();
    const link = `https://gjaaipublication.com/login?con_mobile=${data.ids_phone_no}`;
    setSchoolName(data.name);
    setQrData(link);
    setQrFileName(`${data.name}`);
    setQrOpen(true);
  };

  const downloadQRCode = (e, data) => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    const url = canvas.toDataURL('image/png');
    const link = document.createElement('a');
    link.href = url;
    link.download = `${qrFileName.replace(/[^a-z0-9]/gi, " ")}`;
    link.click();
  };

  const copyQRCode = async () => {
    if (!qrRef.current) return;

    const canvas = qrRef.current.querySelector('canvas');
    if (!canvas) return;

    // Full instructions text
    const instructionsText = `Step-1:

Download ID Solutions app on Playstore

OR

Click this Link:
https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication

Step-2:

Scan This QR For Login`;

    try {
      // Copy image to clipboard
      canvas.toBlob(async (blob) => {
        try {
          if (navigator.clipboard && window.ClipboardItem) {
            // Create a ClipboardItem with both image and text formats
            // Applications can choose which format to paste
            const clipboardItem = new window.ClipboardItem({
              'image/png': blob,
              'text/plain': new Blob([instructionsText], { type: 'text/plain' })
            });
            await navigator.clipboard.write([clipboardItem]);

            enqueueSnackbar('Instructions and QR Code copied to clipboard!', { variant: 'success' });
          } else {
            // Fallback: copy text only
            await navigator.clipboard.writeText(instructionsText);
            enqueueSnackbar('Instructions copied to clipboard! (Image copy not supported in this browser)', { variant: 'info' });
          }
        } catch (err) {
          console.error('Failed to copy with ClipboardItem:', err);
          // Fallback: copy text only
          await navigator.clipboard.writeText(instructionsText);
          enqueueSnackbar('Instructions copied to clipboard!', { variant: 'success' });
        }
      });
    } catch (err) {
      console.error('Failed to copy:', err);
      enqueueSnackbar('Failed to copy QR Code', { variant: 'error' });
    }
  };


  const onCopyLink = (e, data) => {
    const link = `https://forms.gjaaipublication.com/?schoolId=${data.unique_key}&for=parent`;
    navigator.clipboard.writeText(link)
      .then(() => enqueueSnackbar('Link copied to clipboard!', { variant: 'success' }))
      .catch(err => enqueueSnackbar('Failed to copy link.', { variant: 'error' }));
  };
  const onCopyLink1 = (rowData, text) => {
    if (!rowData?.unique_key) {
      enqueueSnackbar('Invalid row data', { variant: 'error' });
      return;
    }
    const encodedText = encodeURIComponent(text);
    const link = `https://forms.gjaaipublication.com/?schoolId=${rowData.unique_key}&for=student&text=${encodedText}`;
    navigator.clipboard
      .writeText(link)
      .then(() =>
        enqueueSnackbar('Link copied to clipboard!', { variant: 'success' })
      )
      .catch(() =>
        enqueueSnackbar('Failed to copy link.', { variant: 'error' })
      );
  };


  const onNavigatetoClass = (e, data) => navigate(`/schools/${data.schoolid}`, { state: data })

  const tableActions = [
    {
      // icon:
      icon: (
        <Tooltip title="Copy Student Link">
          <ContentCopy sx={{ cursor: 'pointer', color: 'gray' }} />
        </Tooltip>
      ),
      onClick: (e, rowData) => {
        // 👇 event may or may not be a real event, so guard it
        if (e?.stopPropagation) e.stopPropagation();
        setSelectedRow(rowData);
        handleOpenTextDialog();
      }, btnType: 'copy'
    },
    {
      icon: (
        <Tooltip title="Copy Parent Link">
          <DifferenceIcon sx={{ cursor: 'pointer', color: 'black' }} />
        </Tooltip>
      ),
      onClick: onCopyLink,
      btnType: 'copy',
    },
    //  { icon: <ContentCopy sx={{ cursor: 'pointer', color: 'gray' }} />, onClick: onCopyLink, btnType: 'copy' },
    {
      icon: (
        <Tooltip title="Activate / Deactivate School">
          <PowerSettingsNew sx={{ cursor: 'pointer', color: '#e65100' }} />
        </Tooltip>
      ),
      onClick: (e, rowData) => {
        if (e?.stopPropagation) e.stopPropagation();
        handleOpenToggleStatusDialog(rowData);
      }
    },
    {
      icon: (
        <Tooltip title="Delete School">
          <Delete sx={{ cursor: 'pointer' }} color='error' />
        </Tooltip>
      ),
      onClick: onDelete,
      btnType: 'del'
    },
    {
      icon: (
        <Tooltip title="Edit School">
          <Edit sx={{ cursor: 'pointer', color: '#7978e9' }} />
        </Tooltip>
      ),
      onClick: onEdit
    },
    {
      icon: (
        <Tooltip title="Download School">
          <Download sx={{ cursor: 'pointer', color: 'darkgreen' }} />
        </Tooltip>
      ),
      onClick: onDownloadClick,
      btnType: 'download'
    },
    {
      icon: (
        <Tooltip title="View QR Code">
          <Visibility sx={{ cursor: 'pointer', color: 'blue' }} />
        </Tooltip>
      ),
      onClick: showQr
    },
    {
      icon: (
        <Tooltip title="Manage Credits (Add / Deduct)">
          <AccountBalanceWallet sx={{ cursor: 'pointer', color: '#ff9800' }} />
        </Tooltip>
      ),
      onClick: (e, data) => {
        e.stopPropagation();
        handleOpenRechargeDialog(data);
      }
    },
    {
      icon: (
        <Tooltip title="View Classes">
          <ArrowForward sx={{ cursor: 'pointer' }} color='primary' />
        </Tooltip>
      ),
      onClick: onNavigatetoClass
    },
  ]

  const filterIdCards = (data) => {
    return data.filter((card) => {
      const searchString =
        `${card.schoolid} ${card.name} ${card.school_login_id} ${card.contact_person} ${card.address}`.toLowerCase();
      return searchString.includes(searchInput.toLowerCase());
    });
  };

  const tableColumns = [
    {
      label: 'School ID',
      key: 'schoolid',
      width: 90,
      align: 'center'
    },
    {
      label: 'Name',
      key: 'name',
      width: 240,
      fixed: false,
    },
    {
      label: 'Status',
      key: 'is_active',
      width: 140,
      align: 'center',
      cell: (rowData) => {
        const isActive = Number(rowData.is_active) === 1;
        const tooltipDetails = [
          `Status: ${isActive ? 'Active' : 'Deactivated'}`,
          rowData.deactivation_reason ? `Reason: ${rowData.deactivation_reason}` : null,
          rowData.last_teacher_login_at ? `Last Teacher Login: ${new Date(rowData.last_teacher_login_at).toLocaleDateString()}` : 'No Teacher Login Recorded',
          rowData.last_user_created_at ? `Last User Created: ${new Date(rowData.last_user_created_at).toLocaleDateString()}` : 'No Users Created in 4+ Months'
        ].filter(Boolean).join('\n');

        return (
          <Tooltip title={<span style={{ whiteSpace: 'pre-line' }}>{tooltipDetails}</span>} arrow>
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleOpenToggleStatusDialog(rowData);
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '6px',
                padding: '4px 10px',
                borderRadius: '14px',
                fontSize: '12px',
                fontWeight: 600,
                backgroundColor: isActive ? '#e8f5e9' : '#ffebee',
                color: isActive ? '#2e7d32' : '#c62828',
                border: `1px solid ${isActive ? '#a5d6a7' : '#ef9a9a'}`,
                boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                userSelect: 'none'
              }}
            >
              <span style={{
                width: 7,
                height: 7,
                borderRadius: '50%',
                backgroundColor: isActive ? '#2e7d32' : '#c62828'
              }} />
              {isActive ? 'Active' : 'Deactivated'}
            </div>
          </Tooltip>
        );
      }
    },
    {
      label: 'Credits',
      key: 'credits',
      width: 120,
      align: 'center',
      cell: (rowData) => {
        const credits = Number(rowData.credits) || 0;
        const isPositive = credits > 0;
        return (
          <Tooltip title="Click to Manage Credits (Add / Deduct)" arrow>
            <div
              onClick={(e) => {
                e.stopPropagation();
                handleOpenRechargeDialog(rowData);
              }}
              style={{
                cursor: 'pointer',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '5px',
                padding: '4px 10px',
                borderRadius: '14px',
                fontSize: '12px',
                fontWeight: 700,
                backgroundColor: isPositive ? '#e8f5e9' : '#ffebee',
                color: isPositive ? '#2e7d32' : '#c62828',
                border: `1px solid ${isPositive ? '#a5d6a7' : '#ef9a9a'}`,
                boxShadow: '0 1px 2px rgba(0,0,0,0.06)',
                userSelect: 'none'
              }}
            >
              <span>{credits}</span>
              <span style={{ fontSize: '10px', fontWeight: 500, opacity: 0.85 }}>Credits</span>
            </div>
          </Tooltip>
        );
      }
    },
    {
      label: 'Login ID',
      key: 'school_login_id',
      width: 140,
      fixed: false,
    },
    {
      label: 'Password',
      key: 'school_secret',
      width: 140,
      fixed: false,
    },
    {
      label: 'Pending IDs',
      key: 'pending_count',
      width: 100,
      align: 'center'
    },
    {
      label: 'Verified IDs',
      key: 'verified_count',
      width: 100,
      align: 'center'
    },
    {
      label: 'Verified Downloaded',
      key: 'verified_is_downloaded',
      width: 120,
      align: 'center',
      render: () => 0
    },
    {
      label: 'Verified Not Downloaded',
      key: 'verified_not_downloaded',
      width: 140,
      align: 'center',
      render: () => 0
    },
    {
      label: 'Total Count',
      key: 'final_count',
      width: 100,
      align: 'center'
    },
    {
      label: 'Last Teacher Login',
      key: 'last_teacher_login_at',
      width: 150,
      align: 'center',
      cell: (rowData) => (
        <span style={{ fontSize: '12px', color: rowData.last_teacher_login_at ? '#333' : '#999' }}>
          {rowData.last_teacher_login_at
            ? new Date(rowData.last_teacher_login_at).toLocaleDateString()
            : 'None'}
        </span>
      )
    },
    {
      label: 'Last User Created',
      key: 'last_user_created_at',
      width: 150,
      align: 'center',
      cell: (rowData) => (
        <span style={{ fontSize: '12px', color: rowData.last_user_created_at ? '#333' : '#999' }}>
          {rowData.last_user_created_at
            ? new Date(rowData.last_user_created_at).toLocaleDateString()
            : 'None'}
        </span>
      )
    },
    {
      label: 'Address',
      key: 'address',
      flexGrow: 1,
      fullText: true,
      minWidth: 200,
    },
    {
      label: 'Contact Person Name',
      key: 'contact_person',
      width: 200,
      fixed: false,
      fullText: true,
    },
    {
      label: 'Delivery Address',
      key: 'del_address',
      width: 150,
      fixed: false,
      fullText: true,
    },
    {
      label: 'Contact Person Mobile No',
      key: 'con_mobile',
      width: 150,
      fixed: false,
      fullText: true,
    }
  ];

  return (
    <StandardPageWrapper
      header="Schools"
      btns={
        <>
          <Button
            variant="outlined"
            onClick={handleSyncInactivity}
            disabled={syncLoading}
            startIcon={syncLoading ? <CircularProgress size={16} /> : <Refresh />}
            sx={{
              marginRight: "1rem",
              borderColor: "#7978e9",
              color: "#7978e9",
              textTransform: "none",
              fontWeight: 600,
              "&:hover": { borderColor: "#5d5cb8", backgroundColor: "rgba(121, 120, 233, 0.08)" }
            }}
          >
            {syncLoading ? "Syncing..." : "Sync Inactivity (4M)"}
          </Button>
          <StandardButton
            variant="contained"
            onClick={onDownloadAllClick}
            loading={downloadAllLoading}
            style={{ background: "darkgreen !important", marginRight: "1rem" }}
            label="Download All"
          />
          <Button
            variant="contained"
            component="label"
            onClick={() => setOpenDialog(true)}
          >
            Add School
          </Button>
        </>
      }
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, flexWrap: 'wrap', px: '10px' }}>
        <TextField
          sx={{ flex: 1, minWidth: '280px' }}
          variant="outlined"
          size="small"
          type="text"
          placeholder="Search Schools by Name, ID, Login ID, Address..."
          value={searchInput}
          onChange={(e) => {
            setSearchInput(e.target.value);
            setPage(1);
          }}
        />

        {/* Filter Pills */}
        <Box sx={{ display: 'flex', gap: 1 }}>
          <Button
            size="small"
            variant={statusFilter === 'all' ? 'contained' : 'outlined'}
            onClick={() => { setStatusFilter('all'); setPage(1); }}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              px: 2,
              fontWeight: 600,
              backgroundColor: statusFilter === 'all' ? '#7978e9' : 'transparent',
              color: statusFilter === 'all' ? '#fff' : '#7978e9',
              borderColor: '#7978e9'
            }}
          >
            All Schools ({totalCount || 0})
          </Button>
          <Button
            size="small"
            variant={statusFilter === 'active' ? 'contained' : 'outlined'}
            onClick={() => { setStatusFilter('active'); setPage(1); }}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              px: 2,
              fontWeight: 600,
              backgroundColor: statusFilter === 'active' ? '#2e7d32' : 'transparent',
              color: statusFilter === 'active' ? '#fff' : '#2e7d32',
              borderColor: '#2e7d32'
            }}
          >
            Active ({activeCount || 0})
          </Button>
          <Button
            size="small"
            variant={statusFilter === 'deactivated' ? 'contained' : 'outlined'}
            onClick={() => { setStatusFilter('deactivated'); setPage(1); }}
            sx={{
              textTransform: 'none',
              borderRadius: '20px',
              px: 2,
              fontWeight: 600,
              backgroundColor: statusFilter === 'deactivated' ? '#d32f2f' : 'transparent',
              color: statusFilter === 'deactivated' ? '#fff' : '#d32f2f',
              borderColor: '#d32f2f'
            }}
          >
            Deactivated ({deactivatedCount || 0})
          </Button>
        </Box>
      </Box>
      <div id="schools">
        <ReactCustomTable
          data={allSchoolData}
          tableColumns={tableColumns}
          loading={allSchoolDataLoading}
          tableActions={tableActions}
          actionsColumnWidth={360}
          deleteID={deleteID}
          deleteLoading={deleteLoading}
          rowDataDeleteKey="schoolid"
          circularColor="#d32f2f"
          downloadId={downloadId}
          downloadLoading={downloadLoading}
          // Pagination props
          total={totalCount}
          limit={limit}
          activePage={page}
          onChangePage={setPage}
          onChangeLimit={(l) => { setLimit(l); setPage(1); }}
        />
      </div>

      <Dialog open={qrOpen} onClose={() => setQrOpen(false)}  >
        <DialogTitle>{`${schoolName}`}</DialogTitle>
        <DialogContent sx={{ padding: "10px" }}>
          {/* Step-1 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-1:
          </Typography>
          <Typography variant="body1" sx={{ mb: 1 }}>
            Download ID Solutions app on Playstore
          </Typography>
          <Typography variant="body1" sx={{ mb: 1, fontWeight: 'bold' }}>
            OR
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Click this Link:{' '}
            <a
              href="https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#7978e9', textDecoration: 'none' }}
            >
              https://play.google.com/store/apps/details?id=com.pixa.gjaaipublication
            </a>
          </Typography>

          {/* Step-2 */}
          <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', color: '#7978e9' }}>
            Step-2:
          </Typography>
          <Typography variant="body1" sx={{ mb: 3 }}>
            Scan This QR For Login
          </Typography>

          {/* QR Code Display */}
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <div ref={qrRef}>
              {qrData ? (
                <QRCodeCanvas value={qrData} size={220} includeMargin={true} />
              ) : (
                <p>No QR Data</p>
              )}
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '10px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Button
              variant="contained"
              color="primary"
              onClick={downloadQRCode}
              startIcon={<Download />}
            >
              Download QR
            </Button>
            <Button
              variant="outlined"
              color="primary"
              onClick={copyQRCode}
              startIcon={<ContentCopy />}
            >
              Copy
            </Button>
          </div>
        </DialogContent>
      </Dialog>

      <Dialog
        open={openCopyTextDialog}
        onClose={handleCloseTextDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            minHeight: 100,
          },
        }}
      >
        <DialogTitle>Enter Unique ID Text</DialogTitle>

        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            label=""
            value={copyText}
            onChange={(e) => setCopyText(e.target.value)}
            sx={{ marginTop: 1 }}
          />
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseTextDialog}>Cancel</Button>
          <Button variant="contained" color="success" onClick={handleSubmitCopyText}>
            Copy Link
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openDeleteDialog}
        onClose={cancelDeleteSchool}
        maxWidth="xs"
        fullWidth
      >
        <DialogTitle sx={{ color: '#d32f2f', fontWeight: 'bold' }}>
          Delete School
        </DialogTitle>

        <DialogContent>
          <Typography>
            Are you sure you want to delete the school
            <strong> "{deleteTarget?.name}"</strong>?
          </Typography>

          <Typography sx={{ mt: 1, color: 'gray' }}>
            This action cannot be undone.
          </Typography>
        </DialogContent>

        <DialogActions>
          <Button variant="outlined" onClick={cancelDeleteSchool}>
            Cancel
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={confirmDeleteSchool}
            disabled={deleteLoading}
          >
            {deleteLoading ? 'Deleting...' : 'Delete'}
          </Button>
        </DialogActions>
      </Dialog>



      <StandardMuiDialogWrapper
        open={openDialog}
        setOpen={setOpenDialog}
        onExited={onExited}
        dialogTitle={`${editActive ? "Update" : "Add"} Schools`}
        onSaveBtnClick={editActive ? onSaveEdit : onAddSchool}
        saveBtnLabel={editActive ? "Update" : "Save"}
        saveBtnLoading={dialogBtnLoading}
      >
        <TextField
          label="School Name"
          variant="outlined"
          name="name"
          value={addSchoolData.name}
          fullWidth
          sx={{ marginTop: 1.5 }}
          onChange={(e) => handleSchoolNameChange(e.target.value)}
        />
        <StandardOutlinedTextfield
          label="School Address"
          name="address"
          val={addSchoolData.address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <Box sx={{ position: 'relative', marginTop: 1.5 }}>
          <TextField
            label="School Login ID"
            variant="outlined"
            name="school_login_id"
            value={addSchoolData.school_login_id}
            fullWidth
            onChange={(e) => setAddSchoolData({ ...addSchoolData, [e.target.name]: e.target.value })}
            InputProps={{
              endAdornment: !editActive && (
                <InputAdornment position="end">
                  <Tooltip title="Regenerate Login ID">
                    <IconButton
                      onClick={regenerateLoginId}
                      edge="end"
                      size="small"
                      disabled={!addSchoolData.name || addSchoolData.name.trim() === ''}
                    >
                      <Refresh />
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              ),
            }}
          />
        </Box>
        <StandardOutlinedTextfield
          label="School Password"
          name="secret_code"
          val={addSchoolData.secret_code}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Name"
          name="contact_person"
          val={addSchoolData.contact_person}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Delivery Address"
          name="del_address"
          val={addSchoolData.del_address}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Contact Person Mobile No"
          name="con_mobile"
          val={addSchoolData.con_mobile}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <StandardOutlinedTextfield
          label="Final Count"
          name="final_count"
          val={addSchoolData.final_count}
          setVal={setAddSchoolData}
          spreadData={addSchoolData}
        />
        <FormControlLabel
          sx={{ mt: 1.5 }}
          control={
            <Switch
              checked={addSchoolData?.is_ids === 1}
              onChange={(e) =>
                setAddSchoolData((prev) => ({
                  ...prev,
                  is_ids: e.target.checked ? 1 : 0,
                }))
              }
              color="primary"
            />
          }
          label="Want to show Teacher QR in APP"
        />

      </StandardMuiDialogWrapper>

      {/* Activate / Deactivate School Dialog */}
      <Dialog open={openStatusDialog} onClose={handleCloseStatusDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ fontWeight: 'bold', color: Number(statusTargetSchool?.is_active) === 1 ? '#d32f2f' : '#2e7d32' }}>
          {Number(statusTargetSchool?.is_active) === 1 ? 'Deactivate School' : 'Reactivate School'}
        </DialogTitle>
        <DialogContent>
          <Typography variant="body1" sx={{ mb: 2 }}>
            School: <strong>{statusTargetSchool?.name}</strong> (ID: {statusTargetSchool?.schoolid})
          </Typography>
          {Number(statusTargetSchool?.is_active) === 1 ? (
            <>
              <Typography variant="body2" sx={{ mb: 2, p: 1.5, bgcolor: '#ffebee', borderRadius: 1, color: '#c62828', border: '1px solid #ef9a9a' }}>
                ⚠️ <strong>Warning:</strong> When this school is deactivated, <strong>no teacher from this school will be able to log in</strong> until the school is reactivated again.
              </Typography>
              <TextField
                fullWidth
                label="Deactivation Reason"
                value={statusReason}
                onChange={(e) => setStatusReason(e.target.value)}
                placeholder="e.g. Manual deactivation, Inactive for 4+ months, Payment pending"
                size="small"
                sx={{ mt: 1 }}
              />
            </>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 2, p: 1.5, bgcolor: '#e8f5e9', borderRadius: 1, color: '#2e7d32', border: '1px solid #a5d6a7' }}>
                ✓ <strong>Notice:</strong> Reactivating this school will immediately allow all teachers from this school to log in again.
              </Typography>
              {statusTargetSchool?.deactivation_reason && (
                <Typography variant="body2" sx={{ color: 'text.secondary', display: 'block', mt: 1 }}>
                  Previous Reason: <em>{statusTargetSchool.deactivation_reason}</em>
                </Typography>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions sx={{ p: 2 }}>
          <Button onClick={handleCloseStatusDialog} disabled={statusBtnLoading}>
            Cancel
          </Button>
          <Button
            variant="contained"
            color={Number(statusTargetSchool?.is_active) === 1 ? "error" : "success"}
            onClick={handleConfirmToggleStatus}
            disabled={statusBtnLoading}
          >
            {statusBtnLoading ? (
              <CircularProgress size={20} color="inherit" />
            ) : Number(statusTargetSchool?.is_active) === 1 ? (
              "Confirm Deactivation"
            ) : (
              "Confirm Activation"
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Manage School Credits Dialog (Add / Deduct / History) */}
      <Dialog 
        open={openRechargeDialog} 
        onClose={() => !rechargeLoading && setOpenRechargeDialog(false)} 
        maxWidth="sm" 
        fullWidth
        PaperProps={{ style: { borderRadius: 12, padding: '4px' } }}
      >
        <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pb: 1, pt: 1.5 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <AccountBalanceWallet sx={{ color: '#1a237e', fontSize: 24 }} />
            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a237e' }}>
              Manage School Credits
            </Typography>
          </Box>
          <IconButton 
            size="small" 
            onClick={() => !rechargeLoading && setOpenRechargeDialog(false)}
            disabled={rechargeLoading}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers sx={{ pt: 1.5, pb: 2 }}>
          {/* School Details & Current Balance Header */}
          {rechargeTargetSchool && (
            <Box sx={{ 
              display: 'flex', 
              justifyContent: 'space-between', 
              alignItems: 'center', 
              p: 1.5, 
              mb: 2, 
              bgcolor: '#f4f6f8', 
              borderRadius: 2,
              border: '1px solid #e0e0e0'
            }}>
              <Box>
                <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a237e', lineHeight: 1.2 }}>
                  {rechargeTargetSchool.name}
                </Typography>
                <Typography variant="caption" sx={{ color: '#666', display: 'block', mt: 0.3 }}>
                  School ID: <strong>{rechargeTargetSchool.schoolid}</strong> {rechargeTargetSchool.school_login_id ? `| Login ID: ${rechargeTargetSchool.school_login_id}` : ''}
                </Typography>
              </Box>
              <Box sx={{ textAlign: 'right' }}>
                <Typography variant="caption" sx={{ color: '#666', display: 'block', fontWeight: 600, mb: 0.3 }}>
                  Current Balance
                </Typography>
                <Chip 
                  label={`${Number(rechargeTargetSchool.credits) || 0} Credits`} 
                  sx={{ 
                    fontWeight: 800, 
                    fontSize: '13px',
                    backgroundColor: (Number(rechargeTargetSchool.credits) || 0) > 0 ? '#e8f5e9' : '#ffebee',
                    color: (Number(rechargeTargetSchool.credits) || 0) > 0 ? '#2e7d32' : '#c62828',
                    border: `1px solid ${(Number(rechargeTargetSchool.credits) || 0) > 0 ? '#a5d6a7' : '#ef9a9a'}`
                  }} 
                />
              </Box>
            </Box>
          )}

          {/* Dialog Tabs */}
          <Tabs
            value={creditDialogTab}
            onChange={(e, val) => setCreditDialogTab(val)}
            sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
          >
            <Tab 
              label="Add / Deduct Credits" 
              icon={<AccountBalanceWallet fontSize="small" />} 
              iconPosition="start" 
              sx={{ textTransform: 'none', fontWeight: 600, fontSize: '13px' }} 
            />
            <Tab 
              label={`History (${creditLogs.length})`} 
              icon={<History fontSize="small" />} 
              iconPosition="start" 
              sx={{ textTransform: 'none', fontWeight: 600, fontSize: '13px' }} 
            />
          </Tabs>

          {/* TAB 0: Add or Deduct Form */}
          {creditDialogTab === 0 && (
            <Box>
              {/* Action Type Selector Cards */}
              <Box sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                <Box
                  onClick={() => { setCreditActionType('add'); setRechargeCredits(''); }}
                  sx={{
                    flex: 1,
                    p: 1.3,
                    borderRadius: 2,
                    cursor: 'pointer',
                    border: '2px solid',
                    borderColor: creditActionType === 'add' ? '#2e7d32' : '#e0e0e0',
                    bgcolor: creditActionType === 'add' ? '#f1f8e9' : '#fafafa',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.2,
                    transition: 'all 0.2s ease',
                    boxShadow: creditActionType === 'add' ? '0 2px 6px rgba(46,125,50,0.15)' : 'none',
                    '&:hover': { borderColor: '#2e7d32' }
                  }}
                >
                  <AddCircleOutline sx={{ color: creditActionType === 'add' ? '#2e7d32' : '#757575', fontSize: 22 }} />
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: creditActionType === 'add' ? '#2e7d32' : '#424242', fontSize: '13px' }}>
                      Add Credits
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#757575', display: 'block', fontSize: '11px', lineHeight: 1.1 }}>
                      Recharge / deposit credits
                    </Typography>
                  </Box>
                </Box>

                <Box
                  onClick={() => { setCreditActionType('deduct'); setRechargeCredits(''); }}
                  sx={{
                    flex: 1,
                    p: 1.3,
                    borderRadius: 2,
                    cursor: 'pointer',
                    border: '2px solid',
                    borderColor: creditActionType === 'deduct' ? '#d32f2f' : '#e0e0e0',
                    bgcolor: creditActionType === 'deduct' ? '#fbe9e7' : '#fafafa',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1.2,
                    transition: 'all 0.2s ease',
                    boxShadow: creditActionType === 'deduct' ? '0 2px 6px rgba(211,47,47,0.15)' : 'none',
                    '&:hover': { borderColor: '#d32f2f' }
                  }}
                >
                  <RemoveCircleOutline sx={{ color: creditActionType === 'deduct' ? '#d32f2f' : '#757575', fontSize: 22 }} />
                  <Box>
                    <Typography variant="subtitle2" sx={{ fontWeight: 700, color: creditActionType === 'deduct' ? '#d32f2f' : '#424242', fontSize: '13px' }}>
                      Deduct Credits
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#757575', display: 'block', fontSize: '11px', lineHeight: 1.1 }}>
                      Subtract credits from balance
                    </Typography>
                  </Box>
                </Box>
              </Box>

              {/* Deduct Zero Balance Warning */}
              {creditActionType === 'deduct' && (Number(rechargeTargetSchool?.credits) || 0) <= 0 && (
                <Alert severity="warning" sx={{ mb: 2, fontSize: '12px' }}>
                  This school currently has 0 credits. Deduction cannot be performed.
                </Alert>
              )}

              {/* Credit Amount Input */}
              <TextField
                label={creditActionType === 'add' ? "Credits to Add" : "Credits to Deduct"}
                type="number"
                fullWidth
                variant="outlined"
                size="small"
                value={rechargeCredits}
                onChange={(e) => setRechargeCredits(e.target.value)}
                inputProps={{ 
                  min: 1,
                  max: creditActionType === 'deduct' ? (Number(rechargeTargetSchool?.credits) || 0) : undefined 
                }}
                disabled={creditActionType === 'deduct' && (Number(rechargeTargetSchool?.credits) || 0) <= 0}
                error={creditActionType === 'deduct' && (parseInt(rechargeCredits, 10) || 0) > (Number(rechargeTargetSchool?.credits) || 0)}
                helperText={
                  creditActionType === 'deduct'
                    ? ((parseInt(rechargeCredits, 10) || 0) > (Number(rechargeTargetSchool?.credits) || 0)
                        ? `Cannot deduct more than current balance (${Number(rechargeTargetSchool?.credits) || 0} Credits)`
                        : (parseInt(rechargeCredits, 10) > 0 
                            ? `Remaining Balance after deduction: ${Math.max(0, (Number(rechargeTargetSchool?.credits) || 0) - parseInt(rechargeCredits, 10))} Credits` 
                            : 'Enter number of credits to deduct'))
                    : (parseInt(rechargeCredits, 10) > 0 
                        ? `Projected Balance after recharge: ${(Number(rechargeTargetSchool?.credits) || 0) + parseInt(rechargeCredits, 10)} Credits` 
                        : 'Enter number of credits to add')
                }
                sx={{ mt: 1, mb: 1.5 }}
                autoFocus
              />

              {/* Quick increment/decrement buttons */}
              {creditActionType === 'add' ? (
                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  {[50, 100, 200, 500, 1000].map(amt => (
                    <Button
                      key={amt}
                      size="small"
                      variant="outlined"
                      onClick={() => setRechargeCredits(String((parseInt(rechargeCredits, 10) || 0) + amt))}
                      sx={{
                        minWidth: 'auto',
                        px: 1.5,
                        py: 0.3,
                        fontSize: '11px',
                        textTransform: 'none',
                        borderRadius: '12px',
                        borderColor: '#2e7d32',
                        color: '#2e7d32',
                        '&:hover': { bgcolor: 'rgba(46, 125, 50, 0.08)', borderColor: '#1b5e20' }
                      }}
                    >
                      +{amt}
                    </Button>
                  ))}
                  <Button
                    size="small"
                    variant="text"
                    onClick={() => setRechargeCredits('')}
                    sx={{ minWidth: 'auto', px: 1, py: 0.3, fontSize: '11px', textTransform: 'none', color: '#888' }}
                  >
                    Clear
                  </Button>
                </Box>
              ) : (
                <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap', alignItems: 'center' }}>
                  {[10, 50, 100, 200, 500]
                    .filter(amt => amt < (Number(rechargeTargetSchool?.credits) || 0))
                    .map(amt => (
                      <Button
                        key={amt}
                        size="small"
                        variant="outlined"
                        onClick={() => setRechargeCredits(String(amt))}
                        sx={{
                          minWidth: 'auto',
                          px: 1.5,
                          py: 0.3,
                          fontSize: '11px',
                          textTransform: 'none',
                          borderRadius: '12px',
                          borderColor: '#d32f2f',
                          color: '#d32f2f',
                          '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.08)', borderColor: '#b71c1c' }
                        }}
                      >
                        -{amt}
                      </Button>
                  ))}
                  {(Number(rechargeTargetSchool?.credits) || 0) > 0 && (
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => setRechargeCredits(String(Number(rechargeTargetSchool?.credits) || 0))}
                      sx={{
                        minWidth: 'auto',
                        px: 1.5,
                        py: 0.3,
                        fontSize: '11px',
                        fontWeight: 700,
                        textTransform: 'none',
                        borderRadius: '12px',
                        borderColor: '#d32f2f',
                        bgcolor: 'rgba(211, 47, 47, 0.05)',
                        color: '#d32f2f',
                        '&:hover': { bgcolor: 'rgba(211, 47, 47, 0.12)' }
                      }}
                    >
                      All ({Number(rechargeTargetSchool?.credits) || 0})
                    </Button>
                  )}
                  <Button
                    size="small"
                    variant="text"
                    onClick={() => setRechargeCredits('')}
                    sx={{ minWidth: 'auto', px: 1, py: 0.3, fontSize: '11px', textTransform: 'none', color: '#888' }}
                  >
                    Clear
                  </Button>
                </Box>
              )}

              {/* Remarks input */}
              <TextField
                label={creditActionType === 'add' ? "Remarks / Note (Optional)" : "Reason for Deduction (Recommended)"}
                fullWidth
                variant="outlined"
                size="small"
                value={rechargeRemarks}
                onChange={(e) => setRechargeRemarks(e.target.value)}
                placeholder={creditActionType === 'add' ? "e.g. Payment via UPI / Advance recharge" : "e.g. Card adjustment / Cancellation / Admin correction"}
                disabled={creditActionType === 'deduct' && (Number(rechargeTargetSchool?.credits) || 0) <= 0}
              />
            </Box>
          )}

          {/* TAB 1: Credit History Logs */}
          {creditDialogTab === 1 && (
            <Box>
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, color: '#444' }}>
                  Transaction History (Latest {creditLogs.length})
                </Typography>
                <IconButton 
                  size="small" 
                  onClick={() => fetchSchoolCreditLogs(rechargeTargetSchool?.schoolid)}
                  disabled={creditLogsLoading}
                  title="Refresh logs"
                >
                  <Refresh fontSize="small" />
                </IconButton>
              </Box>

              {creditLogsLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
                  <CircularProgress size={28} />
                </Box>
              ) : creditLogs.length === 0 ? (
                <Box sx={{ py: 4, textAlign: 'center' }}>
                  <Typography variant="body2" sx={{ color: '#888' }}>
                    No credit transactions recorded yet for this school.
                  </Typography>
                </Box>
              ) : (
                <TableContainer component={Paper} variant="outlined" sx={{ maxHeight: 280, borderRadius: 2 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow sx={{ bgcolor: '#f5f5f5' }}>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }}>Date</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }}>Type</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }} align="right">Amount</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }} align="right">Balance</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }}>Remarks</TableCell>
                        <TableCell sx={{ fontWeight: 700, fontSize: '11px', py: 0.8 }}>By</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {creditLogs.map((log) => {
                        const isAdd = log.action_type === 'RECHARGE' || Number(log.amount) > 0;
                        const isDeduct = log.action_type === 'DEDUCTION';
                        const isDownload = log.action_type === 'DOWNLOAD_DEBIT';
                        return (
                          <TableRow key={log.id} hover sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell sx={{ fontSize: '11px', py: 0.7, whiteSpace: 'nowrap' }}>
                              {formatCreditDate(log.created_at)}
                            </TableCell>
                            <TableCell sx={{ py: 0.7 }}>
                              <Chip 
                                size="small" 
                                label={isAdd ? 'Recharge' : isDeduct ? 'Deduction' : isDownload ? 'Download' : log.action_type}
                                sx={{
                                  fontSize: '10px',
                                  height: '20px',
                                  fontWeight: 700,
                                  bgcolor: isAdd ? '#e8f5e9' : isDeduct ? '#ffebee' : '#e3f2fd',
                                  color: isAdd ? '#2e7d32' : isDeduct ? '#c62828' : '#1565c0',
                                  border: `1px solid ${isAdd ? '#a5d6a7' : isDeduct ? '#ef9a9a' : '#90caf9'}`
                                }}
                              />
                            </TableCell>
                            <TableCell sx={{ fontSize: '11px', fontWeight: 700, py: 0.7, color: isAdd ? '#2e7d32' : '#c62828' }} align="right">
                              {Number(log.amount) > 0 ? `+${log.amount}` : log.amount}
                            </TableCell>
                            <TableCell sx={{ fontSize: '11px', fontWeight: 600, py: 0.7 }} align="right">
                              {log.balance_after}
                            </TableCell>
                            <TableCell sx={{ fontSize: '11px', py: 0.7, maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={log.description || ''}>
                              {log.description || '-'}
                            </TableCell>
                            <TableCell sx={{ fontSize: '10px', color: '#666', py: 0.7, whiteSpace: 'nowrap' }}>
                              {log.performed_by || '-'}
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </Box>
          )}
        </DialogContent>

        <DialogActions sx={{ px: 3, py: 1.5, justifyContent: 'space-between' }}>
          <Button 
            onClick={() => setOpenRechargeDialog(false)} 
            disabled={rechargeLoading}
            sx={{ textTransform: 'none', color: '#666' }}
          >
            {creditDialogTab === 1 ? 'Close' : 'Cancel'}
          </Button>

          {creditDialogTab === 0 && (
            <Button
              variant="contained"
              onClick={handleConfirmCreditAction}
              disabled={
                rechargeLoading || 
                !rechargeCredits || 
                parseInt(rechargeCredits, 10) <= 0 ||
                (creditActionType === 'deduct' && (
                  (Number(rechargeTargetSchool?.credits) || 0) <= 0 || 
                  parseInt(rechargeCredits, 10) > (Number(rechargeTargetSchool?.credits) || 0)
                ))
              }
              sx={{
                backgroundColor: creditActionType === 'deduct' ? '#d32f2f' : '#2e7d32',
                textTransform: 'none',
                fontWeight: 600,
                px: 2.5,
                '&:hover': { 
                  backgroundColor: creditActionType === 'deduct' ? '#b71c1c' : '#1b5e20' 
                }
              }}
            >
              {rechargeLoading ? (
                <CircularProgress size={20} color="inherit" />
              ) : (
                creditActionType === 'deduct' ? 'Deduct Credits' : 'Add Credits'
              )}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </StandardPageWrapper>
  );
}

export default Schools;
